<template>
  <v-card>
    <v-toolbar class="elevation-0" color="#ffffff00" absolute>
      <v-spacer></v-spacer>
      <slot></slot>
    </v-toolbar>
    <v-card-title primary-title>
      <div class="user-info text-xs-center">
        <pi-avatar :user="user"></pi-avatar>
        <div
          class="headline pt-3"
        >{{ user ? user.name : 'Użytkownik' }} {{ user ? user.surname : 'Usunięty' }}</div>
        <div class="grey--text">{{ user ? user.title : '-' }}</div>
      </div>
    </v-card-title>
    <v-card-text
      v-if="user && (user.Groups && user.Groups.length > 0 || user.superadmin)"
      class="text-xs-center"
    >
      <v-chip v-if="user.superadmin" color="accent" text-color="white">
        <v-icon>star</v-icon>
      </v-chip>
      <router-link
        v-for="group in user.Groups"
        :key="group.id"
        :to="`/user/group/${group.id}`"
        class="no-underline"
      >
        <v-chip :color="group.color ? group.color : 'grey'" text-color="white">{{ group.name }}</v-chip>
      </router-link>
    </v-card-text>
    <v-list>
      <v-list-tile>
        <v-list-tile-action>
          <v-icon color="accent">phone</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ user ? user.phone : '-' }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-action>
          <v-icon color="accent">mail</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ user ? user.email : '-' }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <!-- <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat>Wyślij wiadomość</v-btn>
    </v-card-actions>-->
  </v-card>
</template>

<script>
export default {
  props: ["user"],
  data: () => ({})
};
</script>